var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"SGC","header-bg-variant":_vm.modalVariant,"ok-only":"","ok-variant":"primary footer-button"},on:{"ok":_vm.okAction,"hidden":_vm.hiddenAction},model:{value:(_vm.modalVisible),callback:function ($$v) {_vm.modalVisible=$$v},expression:"modalVisible"}},[_vm._v("\n  "+_vm._s(_vm.modalMensaje)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }